import { useMemo, useState, useEffect } from "react";

const pickLang = () => {
    const nav = (navigator.language || navigator.userLanguage || "en").toLowerCase();
    if (nav.startsWith("cs")) return "cs";
    if (nav.startsWith("sk")) return "sk";
    return "en";
};

const get = (obj, path) => {
    return path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
};

export default function useI18n(locales) {
    const [lang, setLang] = useState(pickLang());

    useEffect(() => {
        const onChange = () => setLang(pickLang());
        window.addEventListener("languagechange", onChange);
        return () => window.removeEventListener("languagechange", onChange);
    }, []);

    const t = useMemo(() => {
        return (path) => {
            const val = get(locales[lang] || locales.en, path);
            return val !== undefined ? val : path;
        };
    }, [lang, locales]);

    return { lang, t, setLang };
}
